// extracted by mini-css-extract-plugin
export default {"FormMainDetails":"SingleProductForm_FormMainDetails__oWH8X","AssetsHeader":"SingleProductForm_AssetsHeader__LWGaH","LoaderContainer":"SingleProductForm_LoaderContainer__VJgG9"};